__turbopack_context__.v({
  "count": "styles-module-scss-module__wRucWW__count",
  "enter": "styles-module-scss-module__wRucWW__enter",
  "exit": "styles-module-scss-module__wRucWW__exit",
  "fade-in": "styles-module-scss-module__wRucWW__fade-in",
  "fade-out": "styles-module-scss-module__wRucWW__fade-out",
  "fade-out-80": "styles-module-scss-module__wRucWW__fade-out-80",
  "infoIcon": "styles-module-scss-module__wRucWW__infoIcon",
  "slide-in-from-bottom": "styles-module-scss-module__wRucWW__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__wRucWW__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__wRucWW__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__wRucWW__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__wRucWW__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__wRucWW__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__wRucWW__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__wRucWW__slide-out-to-top",
  "tooltip": "styles-module-scss-module__wRucWW__tooltip",
  "tooltipIcon": "styles-module-scss-module__wRucWW__tooltipIcon",
  "zoom-in": "styles-module-scss-module__wRucWW__zoom-in",
  "zoom-out": "styles-module-scss-module__wRucWW__zoom-out",
});
